import { Component, ViewChild } from "@angular/core";
import { HomePage } from "../pages/home/home";
import { Nav, Platform, NavController, App } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { SecurityConfiguration } from "../security/security.configuration";
import { Storage } from "@ionic/storage";
import { TranslateService} from "@ngx-translate/core";
import { LoginPage } from "../pages/login/login";
import { PDFService } from "../services/pdf.service";
import { JwksValidationHandler, OAuthService } from 'angular-oauth2-oidc';

declare let cordova: any;

@Component({
  templateUrl: "app.html",
})
export class MyApp {

  public rootPage: any;
  public claimsObject: any;
  private navCtrl: NavController;

  constructor(
    private platform: Platform,
    private translateService:TranslateService,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private storage: Storage,
    private app: App,
    private pdfService: PDFService,
    private securityConfig: SecurityConfiguration,
    private oauthService: OAuthService   
    ) {
      if (oauthService.hasValidIdToken()) {
        this.rootPage = HomePage;
      } else {
        if(window.location.hash.indexOf("access_token")>0)
        {
          this.rootPage = HomePage;
          //this.securityConfig.inializeOAuthConfigsNew();   
          //this.rootPage = HomePage;
          // setTimeout(()=>{
          //   if (oauthService.hasValidIdToken()) {
          //     this.rootPage = HomePage;
          //   } 
          // },1000);
        }
        else
        {
          //this.securityConfig.inializeOAuthConfigsNew();   
        }   
        this.securityConfig.inializeOAuthConfigsNew();   
      }
      
    platform.ready().then(() => {
      translateService.setDefaultLang('en');
      translateService.use('en');
      // translateService.setDefaultLang('zh-Hans');
      // translateService.use('zh-Hans');
     
      document.addEventListener('deviceready', () => {
        if (!(this.platform.is("mobileweb") || this.platform.is("core"))){
          this.pdfService.set(cordova.plugins.pdf);
        }    
      });

      statusBar.styleDefault()
      splashScreen.hide();
      //this.securityConfig.inializeOAuthConfigs();

      // if (this.platform.is("mobileweb") || this.platform.is("core")){
      //   if(this.securityConfig.validToken()){
      //     this.rootPage = HomePage;
      //   }
      //   else{
          
      //     this.securityConfig.login();
      //   }      
      // }   
      // else{
      //   this.rootPage = LoginPage
      // }

      
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts